module.exports = __webpack_public_path__ + "static/media/caterspot-bbq.5a184323.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caterspot-bbq.jpg
// module id = 1641
// module chunks = 0